import { render, staticRenderFns } from "./DefaultDocumentInput.vue?vue&type=template&id=449c02ff&scoped=true&"
import script from "./DefaultDocumentInput.vue?vue&type=script&lang=js&"
export * from "./DefaultDocumentInput.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDocumentInput.vue?vue&type=style&index=0&id=449c02ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c02ff",
  null
  
)

export default component.exports